import React from "react";
import DropIn from "braintree-web-drop-in-react";
import settings from '../../../settings.json'
import axios from 'axios'

class Payment extends React.Component {
	instance;

	state = {
        clientToken: null,
        showButton:true,
        message:null
	};

	async componentDidMount() {
        axios.get(settings.url_api+"/api/payment/pay/").then(res=>{
            this.setState({
                clientToken:res.data.token
            });
        })
	}

	async buy() {
        const { nonce } = await this.instance.requestPaymentMethod();
        let data = {nonce : nonce, order_id:this.props.order_id, shipping_price:this.props.shippingPrice}
        axios.post(settings.url_api+"/api/payment/pay/",data).then((res)=>{
            if(res.data.error){
                this.setState({...this.state, message:res.data.msg})
            }else{
				this.setState({...this.state,showButton:false})
				this.props.saveOrder(res.data.transaction_id,res.data.status)
            }
        })
	}

	render() {
		if (!this.state.clientToken) {
			return (
				<div>
                    loading
				</div>
			);
		} else {
			return (
				<div style={{textAlign:"left"}}>
					<div>
						4111 1111 1111 1111 <br/>
						02/23<br/>
						123<br/>

						<br/>
					</div>
					<DropIn
						options={{ authorization: this.state.clientToken }}
						onInstance={instance => (this.instance = instance)}
					/>
					<button hidden={!this.state.showButton} onClick={this.buy.bind(this)}>Buy</button>
				</div>
			);
		}
	}
}

export default Payment;